import { events } from "@constants/tracking";
import AudioPlayerContainerBase, {
	type AudioPlayerRef,
} from "@memorang/ui/components/AudioPlayerContainer";
import { trackCustomEvent } from "analytics";
import { useLocalSearchParams } from "expo-router";
import { forwardRef, useCallback } from "react";

type Props = {
	uri: string;
	itemId?: number;
	onEnd?: () => void;
	onReplay?: () => void;
	hidden?: boolean;
	autoPlay?: boolean;
	waveformWidth?: number;
	updateWaveformWidth?: (width: number) => void;
	showWaveform?: boolean;
	useReanimated?: boolean;
	onDurationLoaded?: (durationInMilliseconds: number) => void;
};

const AudioPlayerContainer = forwardRef<AudioPlayerRef, Props>(
	({ itemId, ...props }, ref) => {
		const { id: sessionId } = useLocalSearchParams<{ id: string }>();

		const handleTracking = useCallback(
			(uri: string, type: "ended" | "started" | "paused") => {
				const getEventName = () => {
					switch (type) {
						case "ended":
							return events.sessionItemAudioEnded;
						case "started":
							return events.sessionItemAudioStarted;
						case "paused":
							return events.sessionItemAudioPaused;
						default:
							return "";
					}
				};
				trackCustomEvent({
					eventName: getEventName(),
					uri,
					type,
					itemId,
					sessionId,
				});
			},
			[itemId, sessionId],
		);

		return (
			<AudioPlayerContainerBase
				{...props}
				ref={ref}
				handleTracking={handleTracking}
			/>
		);
	},
);

export default AudioPlayerContainer;
